import React from 'react';

import PropTypes from 'prop-types';

import SkeletonLine from 'shared-components/components/SkeletonLine';
import Grid from 'shared-components/components/Grid';
import GridItem from 'shared-components/components/GridItem';

const Skeleton = ({ hasSlider, device, maplist }) => (
  <div className={`csa_cardsreel csa_cardsreel__dummy${hasSlider ? ' multiple' : ''} is-rel`}>
    {hasSlider
      ? (
        <Grid className="mb--m" justify="center">
          <div className="csa_cardsreel__dummy__slider pt--s pb--s pr--s pl--s c-bg--w">
            <SkeletonLine width="100%" height="16" round />
          </div>
        </Grid>
      ) : null}
    <Grid className={`csa_cardsreel__dummy__card c-bg--w${maplist ? ' b--s' : ''}`} direction="column">
      <GridItem behavior="fixed">
        <SkeletonLine width="100%" height="180" mb="12" />
      </GridItem>
      <GridItem behavior="stretch" className={`pr--${device === 'smartphone' ? 'ms' : 'm'} pl--${device === 'smartphone' ? 'ms' : 'm'} pb--${device === 'smartphone' ? 'ms' : 's'}`}>
        <Grid style={{ height: '100%' }} direction="column">
          <SkeletonLine width="100%" height="22" mb="4" />
          <SkeletonLine width="75%" height="16" mb={device === 'smartphone' ? 16 : 12} />
          <SkeletonLine width="50%" height="28" mb="4" />
          <SkeletonLine width="100%" height="24" mb="4" />
          <SkeletonLine width="33%" height="24" mb={device === 'smartphone' ? 24 : 16} />
          <GridItem behavior="fixed" push="top">
            <Grid align="center">
              <GridItem behavior="fixed">
                <SkeletonLine width="80" height="32" />
              </GridItem>
              <GridItem push="left" behavior="fixed">
                <Grid>
                  <GridItem behavior="fixed" className="mr--m">
                    <SkeletonLine width="80" height="30" />
                  </GridItem>
                  <GridItem behavior="fixed">
                    <SkeletonLine width="32" height="30" />
                  </GridItem>
                </Grid>
              </GridItem>
            </Grid>
          </GridItem>
        </Grid>
      </GridItem>
    </Grid>
  </div>  
);

export default Skeleton;

Skeleton.propTypes = {
  hasSlider: PropTypes.number,
  device: PropTypes.string,
  maplist: PropTypes.bool,
};

Skeleton.defaultProps = {
  hasSlider: 0,
  device: '',
  maplist: false,
};
